import { lazy } from "react";

// TODO: Deprecate this and use React.lazy directly everywhere.
const Loadable = (importFunction) => {
  return lazy(importFunction);
};

export default Loadable;
